import {
  Box,
  List,
  ListItemButton,
  ListItemIcon,
  ListItemText,
} from "@mui/material";
import { PROFILE_NAV_ITEMS } from "./profileNavConfig";
import useGlobalStyles from "styles/globalStyles";

const SIDEBAR_WIDTH = 260;

export function ProfileSidebarNav({
  value,
  onChange,
}: {
  value: string;
  onChange: (id: string) => void;
}) {
  const globalStyles = useGlobalStyles();

  return (
    <Box
      sx={{
        width: SIDEBAR_WIDTH,
        minWidth: SIDEBAR_WIDTH,
        minHeight: '80vh',
      }}
      className={globalStyles.sectionContainer}
    >
      {/* <Toolbar /> */}
      <List>
        {PROFILE_NAV_ITEMS.map((item) => (
          <ListItemButton
            key={item.id}
            selected={value === item.id}
            onClick={() => onChange(item.id)}
            sx={{ borderRadius: 2, mx: 1, mb: 0.5 }}
          >
            <ListItemIcon sx={{ minWidth: 40 }}>
              {item.icon}
            </ListItemIcon>
            <ListItemText primary={item.label} />
          </ListItemButton>
        ))}
      </List>
    </Box>
  );
}
